module.exports = __webpack_public_path__ + "img/img5-7.accd78b1.jpg";